<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 2C0.895431 2 0 2.89543 0 4V16C0 17.1046 0.895431 18 2 18H18C19.1046 18 20 17.1046 20 16V4C20 2.89543 19.1046 2 18 2H2ZM3.5202 11.603L3.04938 13H2L4.19451 7H5.10025L7.29875 13H6.24539L5.77057 11.603H3.5202ZM5.48728 10.7624L4.64539 8.27335L3.80349 10.7624H5.48728ZM12.5696 13H11.5601L8.97057 8.74313V13H7.9611V7H8.97057L11.5681 11.2734V7H12.5696V13ZM16.8828 7L15.5461 9.84341L14.2095 7H13.0883L15.0394 10.7912V13H16.0529V10.7912L18 7H16.8828Z"
  />
</svg>
